export const GET_DATA = "GET_DATA";
export const CREATE = "CREATE";
export const SUBMIT = "SUBMIT";
export const GET_HISTORY = "GET_HISTORY";